<!-- Page Sidebar Start-->
<div class="logo-wrapper pb-3 pt-3">
  <a routerLink='/'>
    <img class="img-fluid for-light w-75" src="assets/images/logo/fi-we_resized.png" alt="">
    <img class="img-fluid for-dark w-75" src="assets/images/logo/fi-we-dark-resized.png" alt="">
  </a>
  <div class="back-btn" (click)="sidebarToggle()">
    <i class="fa fa-angle-left"></i>
  </div>
  <div class="toggle-sidebar" (click)="sidebarToggle()">
    <app-feather-icons [icon]="'grid'" class="status_toggle middle sidebar-toggle"></app-feather-icons>
  </div>
</div>
<div class="logo-icon-wrapper ">
  <a href="javascript:void(0)">
    <img class="img-fluid ms-4 me-3" src="assets/images/logo/fi-we-2.png" alt="">
   <!--  s ovim ms-3 me-3 sam rijesio problem sirine margina i sirine sakrivenog menija -->
  </a>
</div>


<nav class="sidebar-main" tourAnchor="start-input">
  <div class="left-arrow" id="left-arrow" [class.d-none]="leftArrowNone" (click)="scrollToLeft()">
    <app-feather-icons [icon]="'arrow-left'"></app-feather-icons>
  </div>

  <div id="sidebar-menu" [ngStyle]="{ 'margin-left': layout.margin + 'px', 'margin-right': layout.margin + 'px' }">
    <ul class="sidebar-links sidebar-scroll">
      <li class="back-btn">
        <a href="javascript:void(0)">
          <img class="img-fluid" src="assets/images/logo/fi-we-2.png" alt="">
        </a>
        <div class="mobile-back text-end" (click)="sidebarToggle()">
          <span>Back</span>
          <i class="fa fa-angle-right pl-2" aria-hidden="true"></i>
        </div>
      </li>

      <li class="pin-title sidebar-main-title" [class.show]="pinedItem.length >= 1">
        <div>
          <h6>{{ "PROPERTIES.Omiljeni" | translate }}</h6>
        </div>
      </li>

      @for(menu of menuItems; track menu) {
      @if(menu.main_title) {
      <li class="sidebar-main-title">
        <div>
          <h6 class="lan-1">{{ menu.main_title | translate }}</h6>
        </div>
      </li>
      } @else {
      <div *ngTemplateOutlet="recursiveMenu; context: { $implicit: menu }"></div>
      <ng-template #recursiveMenu let-menu>
        <li [class.sidebar-list]="menu.level == 1" [class.pined]="menu.pined" [id]="menu.id ? menu.id : ''">
          <!--   @if(menu.level == 1) { //pin item
          <i class="fa-solid fa-thumbtack" (click)="pined(menu)"></i>
          } -->

          @if(menu.badge) {
          <label class="badge badge-light-{{ menu.badge_color }}">{{ menu.badge_value | translate }}</label>
          }

          @if(menu.type == 'extTabLink'){
          <a [href]="menu.path" target="_blank">
            {{ menu.title | translate }}
          </a>
          } @else {
          <a [ngClass]="{ 'sidebar-link sidebar-title': menu.level == 1, 'submenu-title': menu.type == 'sub' && menu.level == 2, 'link-nav': menu.type == 'link' && menu.level == 1 }"
            [class.enable-active]="menu.active" routerLinkActive="active" [routerLink]="menu.path"
            (click)="toggletNavActive(menu)">
            @if(menu.icon) {
            <app-svg-icon [icon]="menu.icon" [change]="true"></app-svg-icon>
            }

            @if(menu.level == 1) {
            <span>{{ menu.title | translate }} </span>
            } @else {
            {{ menu.title | translate }}
            }

            @if(menu.children) {
            <div class="according-menu">
              <i class="fa-solid" [ngClass]="menu.active ? 'fa-angle-down' : 'fa-angle-right'"></i>
            </div>
            }
          </a>
          }

          @if(menu.children && menu.children.length) {
          <ul class="sidebar-submenu" [ngStyle]="{'display' : menu.active ? 'block' : 'none'}">
            @for(child of menu.children; track child) {
            <div *ngTemplateOutlet="recursiveMenu; context: { $implicit: child }"></div>
            }
          </ul>
          }
        </li>
      </ng-template>
      }
      }

    </ul>
  </div>
  <div class="right-arrow" id="right-arrow" [class.d-none]="rightArrowNone" (click)="scrollToRight()">
    <app-feather-icons [icon]="'arrow-right'"></app-feather-icons>
  </div>
</nav>